// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CanaryIconButtonTsx from "./CanaryIconButton.tsx";

let make = CanaryIconButtonTsx.CanaryIconButton;

export {
  make,
}
/* make Not a pure module */
